export default class BrandWriteDTO {

    public id: number | undefined;
    public name: string | undefined;
    public label: string | undefined;
    public imageId: number | undefined;

    constructor(data: { [key: string]: any }) {
        this.id = data['id'] || undefined;
        this.name = data['name'] || undefined;
        this.label = data['label'] || undefined;
        this.imageId = data['imageId'] || undefined;
        if(data['image']) {
            this.imageId = data['image'].id;
        }
    }
}
